import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-stafflogin',
  templateUrl: './stafflogin.component.html',
  styleUrls: ['./stafflogin.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class StaffloginComponent implements OnInit {
  
  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin]
  };
  
  constructor( private globalService: GlobalService) { }

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);
  }

}
